var _defs, _rect, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #662d89;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.04,
    y: 0.04,
    width: 99.91,
    height: 99.91,
    rx: 20,
    ry: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.2,27.44c.63.18,1.28.25,1.91.44,4.58,1.32,7.93,5.39,8.47,10.11v25.93c-.57,5.56-5.06,10.04-10.61,10.62h-25.93c-3.48-.43-6.51-2.26-8.5-5.12-1.11-1.59-1.7-3.37-2.04-5.27v-26.31c.62-5.18,5.14-9.9,10.39-10.39h26.31ZM37.52,31.42c-3.75.39-6.74,3.44-7.05,7.21v24.64c.28,3.9,3.4,7.01,7.3,7.32h24.66c3.91-.38,6.96-3.47,7.23-7.4v-24.47c-.29-3.87-3.37-6.96-7.23-7.31l-24.9.03Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.85,50.98c0,6.52-5.28,11.8-11.8,11.8s-11.8-5.28-11.8-11.8,5.28-11.8,11.8-11.8,11.8,5.28,11.8,11.8ZM57.86,50.99c0-4.31-3.5-7.81-7.81-7.81s-7.81,3.5-7.81,7.81,3.5,7.81,7.81,7.81,7.81-3.5,7.81-7.81Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 62.8,
    cy: 38.23,
    r: 2.97
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramTheme);
export default __webpack_public_path__ + "static/media/instagram_theme.654126c2ba6354cd5f82ea4cf5f84afc.svg";
export { ForwardRef as ReactComponent };